import React from "react";

import { Link } from "react-router-dom";

import { EntityStatusBadge } from "@/components/DocumentVisibilityBadge.jsx";

import { DemoFlag } from "@/components/DemoBadge.jsx";

import { usePublicCopy } from "@/i18n/karatePublicI18n.js";

import { useKarateUi } from "@/hooks/useKarateUi.js";



/**

 * @param {{

 *   dojo: import('@/data/types.js').Dojo,

 *   senseiNom?: string,

 *   etudiantsCount?: number,

 * }} props

 */

export function DojoCard({ dojo, senseiNom = "—", etudiantsCount = 0 }) {

  const { copy } = usePublicCopy();

  const d = copy.directory;

  const { localizeDemo } = useKarateUi();



  return (

    <article className="entity-card dojo-card" data-testid={`dojo-card-${dojo.id}`}>

      <header className="entity-card__header">

        <h2 className="entity-card__title">

          {localizeDemo(dojo.nom)}

          <DemoFlag demo={dojo.demo} />

        </h2>

        <EntityStatusBadge statut={dojo.statut} />

      </header>

      <dl className="entity-card__meta">

        <div>

          <dt>{d.columns.city}</dt>

          <dd>{localizeDemo(dojo.ville) || "—"}</dd>

        </div>

        <div>

          <dt>{d.columns.address}</dt>

          <dd>{localizeDemo(dojo.adresse) || "—"}</dd>

        </div>

        <div>

          <dt>Sensei</dt>

          <dd>{senseiNom}</dd>

        </div>

        <div>

          <dt>{d.columns.students}</dt>

          <dd>{etudiantsCount}</dd>

        </div>

      </dl>

      <footer className="entity-card__footer">

        <Link to={`/dojos/${dojo.id}`} className="btn-secondary btn-sm" data-testid={`dojo-detail-link-${dojo.id}`}>

          {d.viewDetails}

        </Link>
        {dojo.adresse ? (
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${dojo.adresse} ${dojo.ville}`)}`}
            target="_blank"
            rel="noreferrer"
            className="btn-secondary btn-sm"
            data-testid={`dojo-directions-${dojo.id}`}
          >
            {d.directions}
          </a>
        ) : null}

      </footer>

    </article>

  );

}


